import { ORGANIZATION_TIER_TYPES } from "@/modules/common/constants";
import NawyPartnersLogo from "@/assets/icons/Domains/Nawy-partners";
import TaskeenDomainLogo from "@/assets/icons/Domains/Taskeen";
import { EnvironmentVariables } from "@/modules/common/types";
import React from "react";
import NawyDomainLogo from "@/assets/icons/Domains/Nawy-Logo";
import { Box } from "@mui/material";

interface DomainLinksProps {
  userTiers?: string[];
}

const DomainLinks: React.FC<DomainLinksProps> = ({ userTiers }) => {
  if (!userTiers || userTiers.length === 0) return null;

  let filteredTiers = [...userTiers];

  if (
    EnvironmentVariables.COMPANY_NAME.toString() ===
    ORGANIZATION_TIER_TYPES.nawy
  ) {
    filteredTiers = filteredTiers.filter(
      (tier) => tier !== ORGANIZATION_TIER_TYPES.nawy
    );
  }
  if (
    EnvironmentVariables.COMPANY_NAME.toString() ===
    ORGANIZATION_TIER_TYPES.partner
  ) {
    filteredTiers = filteredTiers.filter(
      (tier) => tier !== ORGANIZATION_TIER_TYPES.partner
    );
  }
  if (
    EnvironmentVariables.COMPANY_NAME.toString() ===
    ORGANIZATION_TIER_TYPES.taskeen
  ) {
    filteredTiers = filteredTiers.filter(
      (tier) => tier !== ORGANIZATION_TIER_TYPES.taskeen
    );
  }

  const tierLogoMap: Record<
    string,
    { logo: JSX.Element; link: EnvironmentVariables }
  > = {
    [ORGANIZATION_TIER_TYPES.nawy]: {
      logo: <NawyDomainLogo />,
      link: EnvironmentVariables.NAWY_URL,
    },
    [ORGANIZATION_TIER_TYPES.partner]: {
      logo: <NawyPartnersLogo />,
      link: EnvironmentVariables.PARTNERS_URL,
    },
    [ORGANIZATION_TIER_TYPES.taskeen]: {
      logo: <TaskeenDomainLogo />,
      link: EnvironmentVariables.TASKEEN_URL,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "2px",
        marginTop: "8px",
        marginBottom: "8px",
      }}
    >
      {filteredTiers
        .filter((tier) => tierLogoMap[tier])
        .map((tier, index) => {
          const { logo, link } = tierLogoMap[tier];
          return (
            <Box
              key={index}
              onClick={() => window.open(link.toString(), "_blank")}
              style={{ padding: "8px", cursor: "pointer" }}
            >
              {logo}
            </Box>
          );
        })}
    </Box>
  );
};

export default DomainLinks;
